import { render, staticRenderFns } from "./SithMesMstMaterialTask.vue?vue&type=template&id=64a8052c&"
import script from "./SithMesMstMaterialTask.vue?vue&type=script&lang=js&"
export * from "./SithMesMstMaterialTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports